import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { WELCOME_DEMOGRAPHICS } from '../../navigation/routes.constants';
import { usePendingDemographics, useQuery } from '../../../hooks';
import { getPrivateToken } from '../../../actions';

const usePetDemographics = () => {
  const usePendingDemographicsFF = usePendingDemographics();
  const dispatch = useDispatch();
  const store = useSelector(({
    session,
    settings,
  }) => ({ session, settings }));
  const {
    session: { privateToken },
    session,
    settings: { featureFlags },
  } = store;
  const query = useQuery();
  const publicToken = query.get('publicToken');

  useEffect(() => {
    if (publicToken && !privateToken && !featureFlags.loading) {
      dispatch(getPrivateToken({ publicToken }));
    }
  }, [dispatch, featureFlags.loading, publicToken, privateToken]);

  const userName = useMemo(() => {
    if (!session?.userInfo) {
      return '';
    }

    return session.userInfo.FirstName;
  }, [session]);

  const petDemosData = useMemo(() => {
    if (!usePendingDemographicsFF) {
      return [];
    }

    const { userInfo } = session;

    return userInfo?.NeedsPetDemographics || [];
  }, [session]);

  const redirectionRoute = useMemo(() => {
    // if missing pet demos, then fill up them in welcome screen
    if (petDemosData.length > 0 && usePendingDemographicsFF) {
      return WELCOME_DEMOGRAPHICS;
    }

    // otherwise, normal redirection to home
    return '/';
  }, [petDemosData]);

  const inWelcomeScreen = useMemo(() => window.location.pathname
      === WELCOME_DEMOGRAPHICS && usePendingDemographicsFF,
  [window.location.pathname]);

  return {
    inWelcomeScreen,
    isWebView: !!publicToken,
    petDemosData,
    redirectionRoute,
    usePendingDemographicsFF,
    userName,
  };
};

export { usePetDemographics };
